export const roundOmr = (n) => Math.round((Number(n) || 0) * 1000) / 1000;

export const parseDiscountPercent = (dis) => {
  if (!dis || dis === 'no') return null;
  const parsed = parseFloat(dis);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const applyProductDiscount = (price, discountPercent) => {
  const base = parseFloat(price);
  if (!Number.isFinite(base)) return 0;
  if (!discountPercent) return roundOmr(base);
  return roundOmr(base * (1 - discountPercent / 100));
};

export const getCartItemUnitPrice = (item) => roundOmr(parseFloat(item?.price || 0));

export const getCartItemLineTotal = (item) => {
  if (item?.line_total != null && Number.isFinite(Number(item.line_total))) {
    return roundOmr(Number(item.line_total));
  }
  const price = parseFloat(item?.price || 0);
  const qty = parseInt(item?.quantity || 0, 10);
  return roundOmr(price * qty);
};

export const getCartSubtotal = (items = []) =>
  roundOmr(items.reduce((sum, item) => sum + getCartItemLineTotal(item), 0));

export const getCartItemOriginalUnitPrice = (item, { variantPrice, productPrice } = {}) => {
  if (variantPrice != null && Number.isFinite(Number(variantPrice))) {
    return roundOmr(Number(variantPrice));
  }
  if (productPrice != null && Number.isFinite(Number(productPrice))) {
    return roundOmr(Number(productPrice));
  }
  const unitPrice = getCartItemUnitPrice(item);
  const discount = parseDiscountPercent(item?.product?.dis);
  if (discount) {
    return roundOmr(unitPrice / (1 - discount / 100));
  }
  return unitPrice;
};
